<template>
  <div class="workspace-row">
    <ProductRow
      :name="name"
      :discount-tag="discountTag"
      :original-price="originalPrice"
      :final-price="finalPrice"
    />
    <span
      v-tooltip="workspaceNamesTooltip"
      class="sk-text-small-regular text--grey workspace-details"
    >
      {{ displayedWorkspaceNames }}
    </span>
  </div>
</template>

<script>
import ProductRow from './ProductRow.vue';

const ELIPSIS_CHARS = '...';

export default {
  name: 'WorkspaceRow',
  components: {
    ProductRow,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    discountTag: {
      type: String,
      default: null,
    },
    originalPrice: {
      type: String,
      default: null,
    },
    finalPrice: {
      type: String,
      required: true,
    },
    workspaceNames: {
      type: Array,
      required: true,
    },
  },
  computed: {
    isTruncated() {
      return this.workspaceNames.length > 10;
    },
    displayedWorkspaceNames() {
      if (!this.isTruncated) return this.formattedWorkspaceNames;

      const names = this.workspaceNames;
      return `${names.slice(0, 10).join(', ')}${ELIPSIS_CHARS}`;
    },
    workspaceNamesTooltip() {
      if (!this.isTruncated) return '';

      return this.formattedWorkspaceNames.replace(/, /g, '\n');
    },
    formattedWorkspaceNames() {
      return this.workspaceNames.join(', ');
    },
  },
};
</script>

<style lang="scss">
@use './shared' as *;

.workspace-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.workspace-details {
  margin-right: 120px;
  word-break: break-word;
}
</style>
